import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { BreakpointContext } from "components/common/wrappers/withBreakpoint";
import { Button, Fab, MenuItem, Menu } from "@material-ui/core";
import classnames from "classnames";

const MarketingNavigation = ({ children }) => {
  const [anchorBatchEl, setAnchorBatchEl] = useState(null);
  const [anchorAnalyticsEl, setAnchorAnalyticsEl] = useState(null);
  const { isBelow } = useContext(BreakpointContext);
  const isBelowSm = isBelow("sm");
  const handleBatchClick = (event) => {
    setAnchorBatchEl(event.currentTarget);
  };
  const handleAnalyticsClick = (event) => {
    setAnchorAnalyticsEl(event.currentTarget);
  };
  const handleBatchClose = () => {
    setAnchorBatchEl(null);
  };
  const handleAnalyticsClose = () => {
    setAnchorAnalyticsEl(null);
  };
  return (
    <div
      className={classnames({
        "flex flex-wrap justify-center py-2 mx-1 mt-2 px-1 items-center": isBelowSm,
        "flex flex-wrap py-2 mx-1 mt-2 px-1 items-center": !isBelowSm,
      })}
    >
      <Fab
        onClick={handleBatchClick}
        className="focus:outline-none focus:border-none my-5"
        style={{
          boxShadow: "none",
          margin: "0 0.5em",
          width: "27px",
          height: "27px",
          minHeight: "unset",
        }}
      >
        <i className="fas fa-plus mx-auto" />
      </Fab>
      <Link to="/marketing">
        <Button style={{ margin: "0 0.2em" }} size="small">
          <p className="px-1">home</p>
        </Button>
      </Link>
      <Button
        style={{ margin: "0 0.2em" }}
        size="small"
        onClick={handleAnalyticsClick}
      >
        <p className="px-1">analytics</p>
      </Button>
      <Menu
        id="batch-menu"
        anchorEl={anchorBatchEl}
        keepMounted
        open={Boolean(anchorBatchEl)}
        onClose={handleBatchClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        getContentAnchorEl={null}
      >
        <Link to="/marketing/sms">
          <MenuItem onClick={handleBatchClose}>
            <small>SMS</small>
          </MenuItem>
        </Link>
        <Link to="/marketing/email">
          <MenuItem onClick={handleBatchClose}>
            <small>EMAIL</small>
          </MenuItem>
        </Link>
        <Link to="/marketing/push">
          <MenuItem onClick={handleBatchClose}>
            <small>PUSH</small>
          </MenuItem>
        </Link>
      </Menu>
      <Menu
        id="anayltics-menu"
        anchorEl={anchorAnalyticsEl}
        keepMounted
        open={Boolean(anchorAnalyticsEl)}
        onClose={handleAnalyticsClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        getContentAnchorEl={null}
      >
        <Link to="/marketing/sms/analytics">
          <MenuItem onClick={handleAnalyticsClose}>
            <small>SMS</small>
          </MenuItem>
        </Link>
        <Link to="/marketing/email/analytics">
          <MenuItem onClick={handleAnalyticsClose}>
            <small>EMAIL</small>
          </MenuItem>
        </Link>
        <MenuItem disabled onClick={handleAnalyticsClose}>
          <small>PUSH</small>
        </MenuItem>
      </Menu>
      <div
        className={classnames(
          { "ml-auto": !isBelowSm },
          { "mx-auto mt-5 mb-2": isBelowSm },
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default MarketingNavigation;
